'use client';

import React, { useEffect } from 'react';
import { useWebsite } from '@/components/context/WebsiteContext';

const SelectWebsitePackageBasedOnUrlParam = () => {
    const { handleSelectedWebsite } = useWebsite();

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const packageParam = urlParams.get('package');

        if (packageParam) {
            handleSelectedWebsite(parseInt(packageParam));
        }
    }, []);

    return (
        <></>
    );
}

export default SelectWebsitePackageBasedOnUrlParam;